import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, image, type = "website" }) {
  const fullTitle = title
    ? `${title} | Tendres Tétées — Boutique d'allaitement au Sénégal`
    : "Tendres Tétées | La 1ère boutique en ligne dédiée à l'allaitement au Sénégal";
  const desc =
    description ||
    "Matériel d'allaitement à Dakar : tire-lait Medela, recueil de lait Haakaa, coquillages d'allaitement, crème lanoline, sachets de conservation, coussinets lavables et compléments Calmosine. Livraison à domicile à Dakar, paiement à la livraison.";
  const img =
    image ||
    "https://tendrestetees.com/og-image.jpg";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
